
import { Component, Vue } from "vue-property-decorator";
import QuestionnaireStep from "./QuestionnaireStep.vue";
import QuestionnaireSidebar from "./QuestionnaireSidebar.vue";
import { SMQuestionnaire } from "@/store";

@Component({
  components: {
    QuestionnaireStep,
    QuestionnaireSidebar,
  },
})
export default class Questionnaire extends Vue {
  get isOpen() {
    return SMQuestionnaire.isOpen;
  }

  close() {
    SMQuestionnaire.close();
  }
}
